export interface IUser {
    company: number;
    contact: ISamContact;
    iss: string;
    aud: string;
    iat: number;
    nbf: number;
    exp: number;
    sam_uid: number;
    appCode: string;
    sam_permissions?: any;
    sam_contact: ISamContact;
    sam_company: number;
}

export interface ISamContact {
    id: number;
    title?: string;
    xTitle?: string;
    firstName?: string;
    lastName: string;
    email?: string;
    language?: ELanguage;
}

export interface IRequester {
    company: { id: number };
    user: number;
}

export enum ELanguage {
    'en'='en',
    'es'='es',
    'fr'='fr',
    'it'='it',
    'pt'='pt',
}

export const SUPPORTED_LANGUAGES: ELanguage[] = [
    ELanguage.en, ELanguage.es, ELanguage.fr,ELanguage.it,ELanguage.pt
];